import {FC} from 'react';
import {CalendarDays, MapPin} from "lucide-react";
import {formatDateToFrench} from "../utils/dateUtils.ts";
import {Link} from "react-router-dom";

interface Event {
    reference: string;
    title: string;
    eventDate: string;
    eventPlace: string;
    eventImage: string;
}

interface EventCardProps {
    event: Event;
    link: string;
}

const EventCard: FC<EventCardProps> = ({
    event,
                                           link
                                       }) => {
    const {
        title,
        eventDate,
        eventPlace,
        eventImage
    } = event;

    return (
        <Link
            to={link}
            className="bg-white shadow-lg border text-black h-32  rounded-lg max-w-sm flex whitespace-normal break-words">
            <div className="flex-1 px-2 py-2 whitespace-normal break-words">
                <h3 className="text-[#194E6E] font-bold break-words text-base my-1 flex-1 truncate">{title}</h3>
                <div className="flex items-center my-2">
                    <CalendarDays size={20}/>
                    <p className="text-[#4B4E50] text-sm mx-1 flex-1 truncate">
                        {formatDateToFrench(eventDate)}
                    </p>
                </div>
                <div className="flex items-center mt-2">
                    <MapPin size={20}/>
                    <p className="text-[#4B4E50] text-sm mx-1 ">
                        {eventPlace}
                    </p>
                </div>
            </div>

            <div className="w-40">
                <img
                    src={
                        eventImage ||
                        "https://placehold.jp/150x150.png"
                    }
                    alt=""
                    className="h-full w-full object-cover rounded-r-lg"
                />
            </div>
        </Link>
    );
};

export default EventCard;
